import React, { Fragment } from 'react'

const FormCheckboxListElement = ({item}) => {
    return <Fragment>{item?.localeKey}</Fragment>
}

export default FormCheckboxListElement
